export default (params) => ({
  trigger: {
    name: 'sticky_header.add_to_wishlist',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'add_to_wishlist',
      params: {
        sub_feature: null,
      },
    },
  },
});
